import React from 'react';
import moment from 'moment';

const RETRY_TIMEOUT = 2 * 60; // seconds

class RetryLink extends React.Component {
  constructor(props) {
	super(props);
	this.state = {
	  retryText: '',
	  isRetryable: false,
	  isReady: false
	};
	this.intervalId = null;
  }

  componentDidMount() {
	const { requestedAt } = this.props;

	if (requestedAt) {
	  this.setState({ isRetryable: true });

	  let remainingTime = RETRY_TIMEOUT - Math.ceil(moment().diff(moment.utc(requestedAt), 'seconds'));
	  if (remainingTime > 0) {
		  this.updateTimer(remainingTime);
		  this.intervalId = setInterval(() => {  
			remainingTime = RETRY_TIMEOUT - Math.ceil(moment().diff(moment.utc(requestedAt), 'seconds'));
			if(remainingTime > 0) {
				this.updateTimer(remainingTime);				
			}
			else {
			  clearInterval(this.intervalId);
			  // Show "Retry now" if the download is not retryable or already expired
			  this.setState({ isReady: true, retryText: 'Retry now' });
			}
		  }, 1000);
		} 
	}
  }

  updateTimer(seconds) {
	const remainingTime = moment.duration({ seconds });
	const minutes = Math.floor(remainingTime.asMinutes());
	const secondsRemaining = remainingTime.seconds();
	this.setState({ retryText: `Retry in ${minutes}:${secondsRemaining < 10 ? `0${secondsRemaining}` : secondsRemaining}` });
  }
  
  retryCall=()=>{
	this.setState({
		isRetryable: false, isReady: false
	}, ()=>this.props.retry())  
  }

  render() {
	const { isRetryable, retryText, isReady } = this.state;
	return (
	  <div>
		{isRetryable && <a href="#" onClick={event => {
			event.preventDefault();
			isReady && this.retryCall();
		}}>{retryText}</a>}
	  </div>
	);
  }
}

export default RetryLink;
